import { realtimeDb, firestoreDb, firebaseAuth } from '../config/constants'
import firebase from 'firebase';
import log from '../helpers/logger'

export function getFile_cover_url_listList(){

  let dataList = []
  return firestoreDb.collection("file_cover_url_list").get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
        dataList.push(doc)
        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

export function getFile_cover_url_listListByIssue(issue_id){

  let dataList = []
  var fRef = firestoreDb.collection("file_cover_url_list")
  var query = fRef.where("issue_id", "==", issue_id)

  return query.get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        console.log(doc.id, " => ", doc.data());
        dataList.push(doc)
        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

export function updateFile_cover_url_list (id, file_cover_url_list) {
  return firestoreDb.collection("file_cover_url_list").doc(id).update({

    file_url: file_cover_url_list.file_url,
    filename: file_cover_url_list.filename,
    issue_id: file_cover_url_list.issue_id,
    date_created: file_cover_url_list.date_created,
    }).then(() => file_cover_url_list)
}

export function getFile_cover_url_list (id) {

  return firestoreDb.collection("file_cover_url_list").doc(id).get().then(function(doc) {
    if (doc.exists) {
        return doc.data();
    } else {
        return null
    }
  });

}


export function deleteFile_cover_url_list (id) {
  let file_cover_url_list = null
  return firestoreDb.collection("file_cover_url_list").doc(id).update({
    status: 'D'
    }).then(() => file_cover_url_list)
}
// real delete.
export function removeFile_cover_url_list (id) {
  return firestoreDb.collection("file_cover_url_list").doc(id).delete()
}

export function createFile_cover_url_list (file_cover_url_list) {
  //setup date_created from firebase server.
  //file_cover_url_list.date_created = firebase.firestore.FieldValue.serverTimestamp()

  return firestoreDb.collection("file_cover_url_list").add({

    file_url: file_cover_url_list.file_url,
    filename: file_cover_url_list.filename,
    issue_id: file_cover_url_list.issue_id,
    date_created: file_cover_url_list.date_created,
    }).then(() => file_cover_url_list)

}



// WEBPACK FOOTER //
// ./src/services/File_cover_url_listService.js